// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__larsseitFonts_0f9d8c', '__larsseitFonts_Fallback_0f9d8c'"},"className":"__className_0f9d8c"};